export class InputValidatorUtils {
  static onlyNumbers(value: string): string {
    return value.replace(/\D/g, '');
  }

  static onlyAlphabets(value: string): string {
    return value.replace(/[^a-zA-Z ]/g, '');
  }

 static removeScriptTags(value: string): string {
  if (!value) return '';

  // Remove <script>...</script> tags
  value = value.replace(/<script.*?>.*?<\/script>/gi, '');

  // Remove inline event handlers like onerror, onclick
  value = value.replace(/on\w+="[^"]*"/gi, '');
  value = value.replace(/on\w+='[^']*'/gi, '');

  // Remove javascript: protocol
  value = value.replace(/javascript:/gi, '');

  // Optionally remove alert, eval etc.
  value = value.replace(/\b(alert|eval|prompt|confirm)\b/gi, '');

  return value;
}

  
  static hasAtLeastOneAlphabet(value: string): boolean {
  return /[a-zA-Z]/.test(value);
}

}
